const adminApiPrefix = '/admin/api';

export default {
    upload: '/upload/img',
    imgPrefix: 'https://file.algaehub.cn/',
    common: {
        uploadWithThumb: adminApiPrefix + '/common/uploadWithThumb',
    },
    // Taxonomy部分
    taxonomy: {
        // getAllTreeList
        getAllTreeList: adminApiPrefix + '/taxonomy/getAllTreeList',
        // add
        addCat: adminApiPrefix + '/taxonomy/',
        // edit
        editCat: adminApiPrefix + '/taxonomy/',
        // delete
        delCat: adminApiPrefix + '/taxonomy/',
        // submitGenusDetail
        submitGenusDetail: adminApiPrefix + '/taxonomy/submitGenusDetail',
        // getGenusDetailByTaxonomyId
        getGenusDetailByTaxonomyId: adminApiPrefix + '/taxonomy/getGenusDetailByTaxonomyId',
        // getSpeciesDetailByTaxonomyId
        getSpeciesDetailByTaxonomyId: adminApiPrefix + '/taxonomy/getSpeciesDetailByTaxonomyId',
        //submitSpeciesDetail
        submitSpeciesDetail: adminApiPrefix + '/taxonomy/submitSpeciesDetail'
    },
    news: {
        list: adminApiPrefix + '/news/',
        getDetailContent: adminApiPrefix + '/news/getDetailContent/',
        add: adminApiPrefix + '/news/',
        update: adminApiPrefix + '/news/',
        delete: adminApiPrefix + '/news/',
        changeIsTop: adminApiPrefix + '/news/changeIsTop/',
        taxonomyTypeChange: adminApiPrefix + '/news/taxonomyTypeChange/',
    },
    article: {
        list: adminApiPrefix + '/article/',
        add: adminApiPrefix + '/article/',
        update: adminApiPrefix + '/article/',
        delete: adminApiPrefix + '/article/',
    },
    webUser: {
        list: adminApiPrefix + '/web_user_info/',
        changeIsIdentifier: adminApiPrefix + '/web_user_info/changeIsIdentifier/',
        addUser: adminApiPrefix + '/web_user_info/add_user',
    },
    shareInfo: {
        list: adminApiPrefix + '/shareInfo/',
        delete: adminApiPrefix + '/shareInfo/',
        update: adminApiPrefix + '/shareInfo/',
        changeType: adminApiPrefix + '/shareInfo/changeType/',
    },
    identifyInfo: {
        list: adminApiPrefix + '/identifyInfo/',
        delete: adminApiPrefix + '/identifyInfo/',
        getIdentifyListForRequirement: adminApiPrefix + '/identifyInfo/getIdentifyListForRequirement/',
        switchBest: adminApiPrefix + '/identifyInfo/switchBest/',
        deleteResult: adminApiPrefix + '/identifyInfo/deleteResult/',
        modifyResult: adminApiPrefix + '/identifyInfo/modifyResult/',
    },
    database: {
        handleWithNewExcel: adminApiPrefix + '/database/handleWithNewExcel',
        handleWithNewFasta: adminApiPrefix + '/database/handleWithFasta',
        getAllIdNumbers: adminApiPrefix + '/database/getAllIdNumbers',
        getAllFastaInfo: adminApiPrefix + '/database/getAllFastaInfo'
    },
    newsRelease:{
        list:adminApiPrefix + '/newsRelease/'
    },
    // iTaxalgae
    iTaxalgae:{
        // 门信息
        getInfo:adminApiPrefix + '/phylumDetail/',
        addInfo:adminApiPrefix + '/phylumDetail',
        delInfo:adminApiPrefix + '/phylumDetail/',
        // 友情链接
        getLink:adminApiPrefix + '/phylumLink/',
        addLink:adminApiPrefix + '/phylumLink',
        delLink:adminApiPrefix + '/phylumLink/',
        // 动态管理
        getList:adminApiPrefix + '/phylumNews/',
        addNews:adminApiPrefix + '/phylumNews',
        delNews:adminApiPrefix + '/phylumNews/',
        //轮播图
        getRotation:adminApiPrefix + '/phylumRotation/',
        addRotation:adminApiPrefix + '/phylumRotation/',
        delRotation:adminApiPrefix + '/phylumRotation/',
        // 研究方法
        getResearchList:adminApiPrefix+'/phylumResearch/',
        addResearch:adminApiPrefix+'/phylumResearch',
        editResearch:adminApiPrefix+'/phylumResearch',
        delResearch:adminApiPrefix+'/phylumResearch/',
        // 关于我们
        getAboutList:adminApiPrefix+'/phylumAbout/',
        addAbout:adminApiPrefix+'/phylumAbout',
        editAbout:adminApiPrefix+'/phylumAbout',
        delAbout:adminApiPrefix+'/phylumAbout/',
    },
    detect: {
        benthic: adminApiPrefix + '/detect/benthic',
        benthicImport: adminApiPrefix + '/detect/benthic/import',
        users: adminApiPrefix + '/detect/users',
        tasks: adminApiPrefix + '/detect/tasks',
    }
}



// WEBPACK FOOTER //
// ./src/apiList.js